import { isOptionalFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import { useUIOnlyFeatureFlag } from "~/hooks/useUIOnlyFeatureFlag";
export function useIsVerticalNavigationEnabled(): boolean {
    const [isVerticalNavigationEnabled] = useVerticalNavigationFeatureFlag();
    return isOptionalFeatureToggleEnabled("VerticalNavigationFeatureToggle") === true || isVerticalNavigationEnabled;
}
export function useVerticalNavigationFeatureFlag() {
    return useUIOnlyFeatureFlag("Vertical Navigation", false);
}
